import { z } from 'zod'
import { StsDocument } from '~/shared/api'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'
import { dateSchema, ivoryStsDocumentNumberSchema } from '~/shared/lib/schemas'

const baseSchema = StsDocument.schema.pick({
  issuedDate: true,
  issuedBy: true,
})

const temporaryPlateSchema = z.object({
  isTemporaryNumber: z.literal(true),
  expirationDate: dateSchema,
  number: z.string().optional().nullable(),
  plateNumber: z
    .string({ description: buildI18nMessage('form.license plate number') })
    .regex(
      /^\d+[A-Z]{4}\d{2}$/,
      buildI18nMessage('validate.temporary license plate has invalid format'),
    ),
})

const permanentPlateSchema = z.object({
  isTemporaryNumber: z.literal(false),
  number: ivoryStsDocumentNumberSchema,
  plateNumber: z
    .string({ description: buildI18nMessage('form.license plate number') })
    .regex(
      /^[A-Z]{2}-\d{3}-[A-Z]{2}-\d{2}$/,
      buildI18nMessage('validate.permanent license plate has invalid format'),
    ),
})

export const formSchema = baseSchema.and(
  z.discriminatedUnion('isTemporaryNumber', [
    temporaryPlateSchema,
    permanentPlateSchema,
  ]),
)

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = TypeFormSchema
